// pages/video.tsx
"use client";

import { useEffect, useRef } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Navbar from "../components/Navbar";

export default function VideoPage() {
  const playerRef = useRef(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      import("gsap/ScrollTrigger").then((module) => {
        const ScrollTrigger = module.default;
        ScrollTrigger.getAll().forEach((t) => t.kill());
      });
    }
  }, []);

  return (
    <main className="w-screen overflow-x-hidden bg-black">
      <Navbar />
      <section className="relative flex flex-col items-center justify-center w-full h-screen">
        <video
          ref={playerRef}
          src="/img/reefli_video_full.mp4"
          controls
          autoPlay
          muted
          className="w-full h-full object-cover"
        />
      </section>
    </main>
  );
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? "de", ["navbar"])),
    },
  };
};
